import React from "react"

const LangContext = React.createContext({
    value: 1,
    updateLang: () => {}
})

export default LangContext